
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class ModalComparisionRepository {
  private static instance: ModalComparisionRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): ModalComparisionRepository {
    if (!ModalComparisionRepository.instance) {
      ModalComparisionRepository.instance = new ModalComparisionRepository();
    }
    return ModalComparisionRepository.instance;
  }

  public async compare(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.COMPARE_MODELS, payload))?.data;
  }

}
